@use '@scss' as *;

@layer module {
} // layer module










@layer app {
.recurring-preview-block {
            border-radius: $size-8;
            padding: $size-16;
            margin: $size-16 0;
    }

.recurring-preview-block-title {
            margin-bottom: $size-12;
    }

.recurring-preview-block {
            background-color: var(--color-tint-brand);
    }

.recurring-preview-block-title {
            color: var(--color-brand);
            font-size: var(--font-size-sm);
            font-weight: 700;
            letter-spacing: $size-0-4;
            text-transform: uppercase;
    }
} // layer app
